import React, { useEffect } from 'react'

const NotFound = () => {
    useEffect(() => document.title = "e-Book Maggioli")
    return <h1>Ops! 404 not found</h1>
}

export default NotFound;